import React from "react";

import "./shared/styles/crema.less";
import "react-international-phone/style.css";
import {
  AppContextProvider,
  AppLayout,
  AppLocaleProvider,
  AppThemeProvider,
  AuthRoutes,
} from "./domain";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./pages/auth/context";
import ChatPopup from "./shared/components/ChatPopup";
import CookieBanner from "./shared/components/CookieBanner";
import { useSelector } from "react-redux";
import { getIsAuthenticated } from "./domain/app/redux/auth/auth-selectors";

const AppInner = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  return (
    <AuthRoutes>
      <AppLayout />
      {isAuthenticated && <ChatPopup />}
    </AuthRoutes>
  );
};

const App = () => {
  return (
    <AppContextProvider>
      <AuthProvider>
        <AppThemeProvider>
          <AppLocaleProvider>
            <BrowserRouter>
              <AppInner />
            </BrowserRouter>
          </AppLocaleProvider>
          <CookieBanner />
        </AppThemeProvider>
      </AuthProvider>
    </AppContextProvider>
  );
};

export default App;
